// extracted by mini-css-extract-plugin
export default {"contactForm":"ContactPage_contactForm__UmNyG","formGroup":"ContactPage_formGroup__2klzF"};